// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-select--none {\n  user-select: none; }\n\n.user-select--initial {\n  user-select: initial; }\n\n.text-center {\n  text-align: center; }\n", ""]);
// Exports
module.exports = exports;
